import React, { useState } from 'react';
import UserImage from 'images/user.png';
import { getUserProfilePictureUrl } from 'utils/user';

interface UserAvatarProps {
  alt?: string;
  hasProfilePicture?: boolean;
  modifiedAt?: string | Date;
  previewSrc?: string | null;
  size?: number;
  style?: React.CSSProperties;
  userId?: string;
}

const UserAvatar = ({
  alt = 'User profile',
  hasProfilePicture,
  modifiedAt,
  previewSrc,
  size = 32,
  style,
  userId,
}: UserAvatarProps) => {
  const pictureUrl = userId && hasProfilePicture
    ? getUserProfilePictureUrl(userId, modifiedAt)
    : null;
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const src = previewSrc
    || (pictureUrl && failedUrl !== pictureUrl ? pictureUrl : UserImage);

  return (
    <img
      alt={alt}
      height={size}
      onError={() => {
        if (pictureUrl) {
          setFailedUrl(pictureUrl);
        }
      }}
      src={src}
      style={{
        borderRadius: '50%',
        objectFit: 'cover',
        ...style,
      }}
      width={size}
    />
  );
};

export default UserAvatar;
